import React from 'react'
import imgIntro from "../../media/intro.svg"
import "./intro.css"

export const Intro = () => {
  return (
    <div className="contIntro">
        <img className="imgIntro" src={imgIntro} alt="imgIntro" />
    </div>
   
  )
}



